import type { GridLayoutDefaults } from './defaultSettings';

export const mapGridLayoutSettings = (settings: GridLayoutDefaults) => {
  const {
    gridColumnsMode,
    gridColumnsDesktopLarge,
    gridColumnsDesktopMedium,
    gridColumnsDesktopSmall,
    gridColumnsTablet,
    gridColumnsMobile,
    gridItemSpacing,
    gridShowLoadMoreButton,
    showLoadMoreButton,
    limitTotalNumberOfItems,
    totalNumberOfItems,
    gridRows,
    gridRowsOnMobile
  } = settings;

  return {
    columnsMode: gridColumnsMode,
    columnsDesktopLarge: gridColumnsDesktopLarge,
    columnsDesktopMedium: gridColumnsDesktopMedium,
    columnsDesktopSmall: gridColumnsDesktopSmall,
    columnsTablet: gridColumnsTablet,
    columnsMobile: gridColumnsMobile,
    itemSpacing: gridItemSpacing,
    // Приоритет: новая настройка ?? старая настройка
    showLoadMoreButton: showLoadMoreButton ?? gridShowLoadMoreButton,
    limitTotalNumberOfItems,
    totalNumberOfItems,
    rows: gridRows,
    rowsOnMobile: gridRowsOnMobile
  };
};
